<template>
  <div class="h-full w-full overflow-y-auto">
    <div class="mt-10px cursor-default">
      <el-tag class="mr-10px" effect="dark" size="small" type="success">已执行</el-tag>
      <el-tag class="mr-10px" effect="dark" size="small" type="warning">正在执行</el-tag>
      <el-tag class="mr-10px" effect="dark" size="small" type="info">待执行</el-tag>
    </div>
    <div class="flex flex-col items-center mt-20px">
      <el-tooltip placement="top" v-for="(item, index) in emergencyItems" :key="index">
        <div slot="content" class="text-sm">
          <div><span class="text-hex-333333 font-bold">应急预案等级：</span>{{ item.playLevel }}</div>
          <div><span class="text-hex-333333 font-bold">应急响应等级：</span>{{ item.pesponseLevel }}</div>
          <div><span class="text-hex-333333 font-bold">班组：</span>{{ item.team }}</div>
          <div><span class="text-hex-333333 font-bold">操作卡明细名称：</span>{{ item.operationDetailName }}</div>
          <div><span class="text-hex-333333 font-bold">组长：</span>{{ item.groupLeader }}</div>
          <div><span class="text-hex-333333 font-bold">成员：</span>{{ item.member }}</div>
          <div><span class="text-hex-333333 font-bold">工作内容：</span>{{ item.workContent }}</div>
          <div><span class="text-hex-333333 font-bold">状态：</span>{{ item.status }}</div>
          <div><span class="text-hex-333333 font-bold">执行人：</span>{{ item.execute }}</div>
          <div><span class="text-hex-333333 font-bold">执行时间：</span>{{ item.executeTiem }}</div>
        </div>
        <el-tag
          effect="dark"
          class="flow-tag"
          :type="
            item.status === '已执行' ? 'success' : item.status === '正在执行' ? 'warning' : 'info'
          "
          >{{ item.operationDetailName }}</el-tag
        >
      </el-tooltip>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EmergencyResponseDetailLeft',
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      emergencyItems: [],
    }
  },
  watch: {
    transferProps: {
      handler(val) {
        this.getEmergencyFlows()
      },
      deep: true,
    },
  },
  created() {
    this.getEmergencyFlows()
  },
  methods: {
    async getEmergencyFlows() {
      axios({
        method: 'GET',
        url: `${this.transferProps.baseUrl}/openapi/ecologynew/detail/V1.0?token=portal_js&id=${this.transferProps.row.id}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          this.emergencyItems = res.data.data || []
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.el-tag.el-tag--success {
    background-color: #156140;
    border-color: #52e181;
    color: #fff;
}

::v-deep.el-tag.el-tag--warning {
    background-color: #526032;
    border-color: #cabb4f;
    color: #fff;
}

::v-deep.el-tag.el-tag--info {
    background-color: #20656d !important;
    border-color: #46a4af !important;
    color: #fff !important;
}

.flow-tag {
  position: relative;
  margin-bottom: 30px;
  cursor: default;
}

.flow-tag:not(:last-child):after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -31px;
  width: 2px;
  height: 30px;
  background-color: #ccc;
  transform: translateX(-50%);
}
</style>
